import { render, staticRenderFns } from "./DocumentoActivoPage.vue?vue&type=template&id=6b3eec10"
import script from "./DocumentoActivoPage.js?vue&type=script&lang=js&external"
export * from "./DocumentoActivoPage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports